/* eslint-disable no-console */
/* eslint no-underscore-dangle: ["error", { "allow": ["__typename"] }] */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ContentLoader from 'react-content-loader';
// graphQL
import gql from 'graphql-tag';
// our components
import { Query } from 'components/common/Query';
import { userKinds } from 'config';
import { PageInfo } from 'components/common/Paginator/PaginatorContainer';
import UserSelect from './Select';

/**
 * Query to fetch users from api
 */
export const ADMIN_USERS_QUERY = gql`
  query UserList(
    $first: Int
    $after: String
    $last: Int
    $before: String
    $rank: [FilterRank]
    $contactInfo: String
  ) {
    adminUsers(
      first: $first
      after: $after
      last: $last
      before: $before
      rank: $rank
      contactInfo: $contactInfo
    ) {
      pageInfo {
        ...PaginatorPageInfo
      }
      edges {
        node {
          id
          fullname
          email
          phone
          photo {
            gcsKey
            url
          }
        }
      }
    }
  }
  ${PageInfo}
`;

/**
 * Query to fetch agencies from api
 */
export const AGENCIES_QUERY = gql`
  query AgenciesList(
    $first: Int
    $userType: [FilterUserType]!
    $contactInfo: String
  ) {
    adminUsers(first: $first, userType: $userType, contactInfo: $contactInfo) {
      edges {
        node {
          id
          email
          fullname
          photo {
            gcsKey
            url
          }
        }
      }
    }
  }
`;

/**
 * Query to fetch user from agencies from api
 */
export const USER_AGENCY_QUERY = gql`
  query UserAgenciyList(
    $first: Int
    $userType: [FilterUserType]!
    $agency: ID
    $contactInfo: String
  ) {
    adminUsers(
      first: $first
      userType: $userType
      agency: $agency
      contactInfo: $contactInfo
    ) {
      edges {
        node {
          id
          email
          fullname
          photo {
            gcsKey
            url
          }
        }
      }
    }
  }
`;

class UserSelectContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filters: {
        first: 50,
        contactInfo: '',
      },
    };
  }

  /**
   * @description
   * Filter user according to filters.
   *
   * @param {Object} filters - Applied filters.
   */
  handleFilter = filters => {
    this.setState({ filters });
  };

  handleQuery = () => {
    const { listAgencies, listUserAgencies, agency } = this.props;
    const { filters } = this.state;

    if (listAgencies) {
      return {
        query: AGENCIES_QUERY,
        variables: { userType: userKinds.AGENCY, ...filters },
      };
    }
    if (agency && Object.keys(agency).length > 0) {
      return {
        query: USER_AGENCY_QUERY,
        variables: {
          userType: 'USER_AGENCY',
          agency: agency.id,
          ...filters,
        },
      };
    }

    if (listUserAgencies) {
      return {
        query: USER_AGENCY_QUERY,
        variables: {
          userType: 'USER_AGENCY',
          ...filters,
        },
      };
    }

    return {
      query: ADMIN_USERS_QUERY,
      variables: {
        ...filters,
      },
    };
  };

  /**
   * @description
   * Render UserSelect component.
   *
   * @returns {*} UserSelect component.
   */
  render() {
    const { selectUser } = this.props;
    const { filters } = this.state;

    const apiCall = this.handleQuery();

    return (
      <Query
        query={apiCall.query}
        variables={apiCall.variables}
        fetchPolicy="cache-and-network"
        notifyOnNetworkStatusChange
      >
        {({ data, loading }) => {
          if (loading) {
            return (
              <ContentLoader
                height={491}
                width={566}
                speed={2}
                primaryColor="#d9d9d9"
                secondaryColor="#ecebeb"
              >
                <path
                  // eslint-disable-next-line max-len
                  d="M68.5,79 C83.6878306,79 96,91.3121694 96,106.5 C96,121.687831 83.6878306,134 68.5,134 C53.3121694,134 41,121.687831 41,106.5 C41,91.3121694 53.3121694,79 68.5,79 Z M106.5,92 L193.5,92 C197.642136,92 201,95.3578644 201,99.5 C201,103.642136 197.642136,107 193.5,107 L106.5,107 C102.357864,107 99,103.642136 99,99.5 C99,95.3578644 102.357864,92 106.5,92 Z M104,113 L193.5,113 C196.261424,113 198.5,115.238576 198.5,118 C198.5,120.761424 196.261424,123 193.5,123 L104,123 C101.238576,123 99,120.761424 99,118 C99,115.238576 101.238576,113 104,113 Z M217,113 L306.5,113 C309.261424,113 311.5,115.238576 311.5,118 C311.5,120.761424 309.261424,123 306.5,123 L217,123 C214.238576,123 212,120.761424 212,118 C212,115.238576 214.238576,113 217,113 Z M36,140 L496,140 L496,142 L36,142 L36,140 Z M68.5,155 C83.6878306,155 96,167.312169 96,182.5 C96,197.687831 83.6878306,210 68.5,210 C53.3121694,210 41,197.687831 41,182.5 C41,167.312169 53.3121694,155 68.5,155 Z M106.5,168 L213.5,168 C217.642136,168 221,171.357864 221,175.5 C221,179.642136 217.642136,183 213.5,183 L106.5,183 C102.357864,183 99,179.642136 99,175.5 C99,171.357864 102.357864,168 106.5,168 Z M104,189 L157.5,189 C160.261424,189 162.5,191.238576 162.5,194 C162.5,196.761424 160.261424,199 157.5,199 L104,199 C101.238576,199 99,196.761424 99,194 C99,191.238576 101.238576,189 104,189 Z M182,189 L271.5,189 C274.261424,189 276.5,191.238576 276.5,194 C276.5,196.761424 274.261424,199 271.5,199 L182,199 C179.238576,199 177,196.761424 177,194 C177,191.238576 179.238576,189 182,189 Z M36,216 L496,216 L496,218 L36,218 L36,216 Z M68.5,231 C83.6878306,231 96,243.312169 96,258.5 C96,273.687831 83.6878306,286 68.5,286 C53.3121694,286 41,273.687831 41,258.5 C41,243.312169 53.3121694,231 68.5,231 Z M106.5,244 L225.5,244 C229.642136,244 233,247.357864 233,251.5 C233,255.642136 229.642136,259 225.5,259 L106.5,259 C102.357864,259 99,255.642136 99,251.5 C99,247.357864 102.357864,244 106.5,244 Z M104,265 L193.5,265 C196.261424,265 198.5,267.238576 198.5,270 C198.5,272.761424 196.261424,275 193.5,275 L104,275 C101.238576,275 99,272.761424 99,270 C99,267.238576 101.238576,265 104,265 Z M212,265 L263.5,265 C266.261424,265 268.5,267.238576 268.5,270 C268.5,272.761424 266.261424,275 263.5,275 L212,275 C209.238576,275 207,272.761424 207,270 C207,267.238576 209.238576,265 212,265 Z M36,292 L496,292 L496,294 L36,294 L36,292 Z M68.5,307 C83.6878306,307 96,319.312169 96,334.5 C96,349.687831 83.6878306,362 68.5,362 C53.3121694,362 41,349.687831 41,334.5 C41,319.312169 53.3121694,307 68.5,307 Z M106.5,320 L278.5,320 C282.642136,320 286,323.357864 286,327.5 C286,331.642136 282.642136,335 278.5,335 L106.5,335 C102.357864,335 99,331.642136 99,327.5 C99,323.357864 102.357864,320 106.5,320 Z M104,341 L148.5,341 C151.261424,341 153.5,343.238576 153.5,346 C153.5,348.761424 151.261424,351 148.5,351 L104,351 C101.238576,351 99,348.761424 99,346 C99,343.238576 101.238576,341 104,341 Z M170,341 L259.5,341 C262.261424,341 264.5,343.238576 264.5,346 C264.5,348.761424 262.261424,351 259.5,351 L170,351 C167.238576,351 165,348.761424 165,346 C165,343.238576 167.238576,341 170,341 Z M36,368 L496,368 L496,370 L36,370 L36,368 Z M68.5,383 C83.6878306,383 96,395.312169 96,410.5 C96,425.687831 83.6878306,438 68.5,438 C53.3121694,438 41,425.687831 41,410.5 C41,395.312169 53.3121694,383 68.5,383 Z M106.5,396 L204.5,396 C208.642136,396 212,399.357864 212,403.5 C212,407.642136 208.642136,411 204.5,411 L106.5,411 C102.357864,411 99,407.642136 99,403.5 C99,399.357864 102.357864,396 106.5,396 Z M104,417 L155.5,417 C158.261424,417 160.5,419.238576 160.5,422 C160.5,424.761424 158.261424,427 155.5,427 L104,427 C101.238576,427 99,424.761424 99,422 C99,419.238576 101.238576,417 104,417 Z M174,417 L225.5,417 C228.261424,417 230.5,419.238576 230.5,422 C230.5,424.761424 228.261424,427 225.5,427 L174,427 C171.238576,427 169,424.761424 169,422 C169,419.238576 171.238576,417 174,417 Z M36,444 L496,444 L496,446 L36,446 L36,444 Z M36,20 L481,20 C489.284271,20 496,26.7157288 496,35 C496,43.2842712 489.284271,50 481,50 L36,50 C27.7157288,50 21,43.2842712 21,35 C21,26.7157288 27.7157288,20 36,20 Z"
                  fill="#D8D8D8"
                />
              </ContentLoader>
            );
          }
          return (
            <UserSelect
              allUsers={data.adminUsers}
              selectUser={selectUser}
              filter={this.handleFilter}
              appliedFilter={filters}
            />
          );
        }}
      </Query>
    );
  }
}

/**
 * PermissionSelect PropTypes
 * @callback selectUser - callback function pass to UserSelect
 */

UserSelectContainer.propTypes = {
  selectUser: PropTypes.func.isRequired,
  listAgencies: PropTypes.bool,
  listUserAgencies: PropTypes.bool,
  agency: PropTypes.instanceOf(Object),
};

UserSelectContainer.defaultProps = {
  listAgencies: false,
  listUserAgencies: false,
  agency: {},
};

export default UserSelectContainer;
